import { doc, deleteDoc } from "firebase/firestore";
import { db, storage } from "@poseidon/firebase";
import { ref, deleteObject, getDownloadURL } from "firebase/storage";

export const removeFile = async (file) => {
  try {
    await deleteFile(file.uploadPath);
    await removeFileFromDb(file.id);
    return "File deleted.";
  } catch (error) {
    if (error.code === "storage/object-not-found") {
      // remove anyway
      await removeFileFromDb(file.id);
      return "File already removed, deleted from Db";
    }
    return new Error(error.code);
  }
};

const deleteFile = async (path) => {
  // Create a reference to file
  const storageRef = ref(storage, path);

  // Delete the file
  await deleteObject(storageRef);
};

export const downloadFile = async (path) => {
  // Create a reference to file
  const storageRef = ref(storage, path);

  // Download the file
  return getDownloadURL(storageRef)
    .then((url) => {
      window.open(url, "_blank");
    })
    .catch((error) => {
      console.error(error.code);
      return Error(error);
    });
};

const removeFileFromDb = async (id) => {
  return await deleteDoc(doc(db, "files", id));
};
